module.exports = __webpack_public_path__ + "img/001.b75b57dc.png";